import { LEGAL, TBD, LAW_NC, publisherLabel } from "@/lib/legal";

const S = LEGAL.serviceName;
const P = publisherLabel();

export const DISCLAIMER = `${S} constitue un outil d'assistance à la prévention, à l'analyse préalable des risques et à la traçabilité. Il ne se substitue ni au jugement professionnel de l'utilisateur, ni aux procédures HSE de l'entreprise, ni aux obligations réglementaires, habilitations, permis ou dispositifs de sécurité requis.`;

export const legalNotice = {
  intro: `Informations relatives à l'éditeur et à l'hébergement du service ${S}.`,
  draft: true,
  sections: [
    { id: "editeur", title: "Éditeur du service", blocks: [
      { table: { head: ["Information", "Valeur"], rows: [
        ["Service", S],
        ["Écosystème", `${LEGAL.brand} (${LEGAL.territory})`],
        ["Raison sociale", LEGAL.companyName],
        ["Forme juridique", LEGAL.legalForm],
        ["Capital social", LEGAL.capital],
        ["RIDET", LEGAL.ridet],
        ["RCS", LEGAL.rcs],
        ["Siège social", LEGAL.address],
        ["Représentant légal", LEGAL.representative],
      ] } },
      { callout: `${LEGAL.brand} désigne la marque et l'écosystème auquel appartient ${S}. Tant que la raison sociale n'est pas renseignée, ${LEGAL.brand} n'est pas présenté comme une personne morale.` },
    ] },
    { id: "publication", title: "Responsable de la publication", blocks: [LEGAL.publicationManager] },
    { id: "contact", title: "Contact", blocks: [
      { table: { head: ["Canal", "Coordonnée"], rows: [
        ["E-mail", LEGAL.contactEmail],
        ["Téléphone", LEGAL.phone],
        ["Page de contact", "[Contact](/infos/contact)"],
      ] } },
    ] },
    { id: "hebergement", title: "Hébergement", blocks: [
      { table: { head: ["Information", "Valeur"], rows: [
        ["Plateforme actuelle", LEGAL.currentPlatform],
        ["Hébergeur définitif", LEGAL.host],
        ["Adresse de l'hébergeur", LEGAL.hostAddress],
        ["Localisation", LEGAL.hostLocation],
      ] } },
    ] },
    { id: "pi", title: "Propriété intellectuelle", blocks: [
      `Les éléments composant ${S} (marque, textes, interface, code, référentiels globaux) sont protégés. Toute reproduction ou réutilisation sans autorisation est interdite. Les données saisies par les clients restent leur propriété.`,
    ] },
  ],
};

export const cgu = {
  intro: `Conditions générales d'utilisation du service ${S}.`,
  draft: true,
  sections: [
    { id: "objet", title: "Objet", blocks: [
      `Les présentes CGU encadrent l'utilisation de ${S}, édité par ${P}, solution d'aide à la prévention terrain : Take 5, inspections d'équipements et de véhicules, équipes, supervision et traçabilité.`,
      { callout: DISCLAIMER, tone: "warn" },
    ] },
    { id: "compte", title: "Compte et Workplace", blocks: [{ list: [
      "Un compte est obligatoire pour accéder aux fonctions métier.",
      "Chaque utilisateur appartient à un ou plusieurs Workplaces et dispose d'un rôle par Workplace, attribué par l'administrateur.",
      "L'utilisateur est responsable de la confidentialité de ses identifiants et signale sans délai toute utilisation suspecte.",
    ] }] },
    { id: "usage", title: "Utilisation professionnelle", blocks: [{ list: [
      "Le service est destiné à un usage professionnel, dans le cadre fixé par l'entreprise cliente.",
      "L'utilisateur agit dans la limite des droits attribués par son rôle.",
      "Il veille à l'exactitude et à la sincérité de ses saisies (réponses, dangers, mesures, décisions, résultats d'inspection).",
      "Les photos doivent être utiles à l'analyse de sécurité ; l'utilisateur évite d'identifier des personnes sans nécessité.",
    ] }] },
    { id: "interdits", title: "Usages interdits", blocks: [{ list: [
      "Utiliser le service de manière illicite ou contraire aux règles de l'entreprise.",
      "Tenter de contourner les permissions, d'accéder aux données d'un autre Workplace ou d'un autre utilisateur.",
      "Perturber le fonctionnement du service ou en tester la sécurité hors du cadre du [signalement de vulnérabilité](/infos/signalement-vulnerabilite).",
      "Saisir des contenus injurieux, discriminatoires ou des données sensibles sans nécessité.",
    ] }] },
    { id: "entreprise", title: "Responsabilités de l'entreprise utilisatrice", blocks: [
      "L'entreprise utilisatrice reste responsable :",
      { list: [
        "de ses procédures HSE, autorisations, habilitations et permis de travail ;",
        "de l'information de ses salariés sur l'utilisation de l'outil ;",
        "lorsqu'elles sont applicables, des procédures d'information ou de consultation de ses représentants du personnel liées au déploiement de l'outil.",
      ] },
      `${S} ne réalise pas automatiquement ces obligations.`,
    ] },
    { id: "disponibilite", title: "Disponibilité et évolution", blocks: [
      "Le service est fourni avec une obligation de moyens. Il peut être interrompu pour maintenance ou en cas d'incident. Le mode hors ligne permet de poursuivre la saisie jusqu'à 72 h sans connexion. Les fonctionnalités peuvent évoluer ; aucun niveau de service garanti n'est proposé à ce stade (À compléter dans les conditions contractuelles).",
    ] },
    { id: "suspension", title: "Suspension", blocks: [
      "Un administrateur peut désactiver un utilisateur ou le retirer de son Workplace. L'éditeur peut suspendre un accès ou un Workplace en cas d'usage contraire aux présentes CGU ou de risque pour la sécurité du service.",
    ] },
    { id: "pi", title: "Propriété intellectuelle", blocks: [
      `${S} et ses référentiels globaux restent la propriété de leur éditeur. Le client conserve la propriété des données qu'il saisit.`,
    ] },
    { id: "donnees", title: "Données personnelles", blocks: [
      `Les données sont traitées ${LAW_NC}. Voir la [politique de confidentialité](/infos/confidentialite) et le [DPA](/infos/dpa).`,
    ] },
    { id: "droit", title: "Droit applicable", blocks: [`Droit applicable et juridiction compétente : ${TBD}.`] },
  ],
};

const fin = "À finaliser avant activation commerciale";
export const commercial = {
  intro: `Conditions commerciales du service ${S}.`,
  draft: true,
  sections: [
    ["offres", "Offres"], ["prix", "Prix"], ["utilisateurs", "Nombre d'utilisateurs"], ["facturation", "Facturation"],
    ["renouvellement", "Renouvellement"], ["changement", "Changement d'offre"], ["resiliation", "Résiliation"],
    ["paiement", "Paiement"], ["taxes", "Taxes"], ["factures", "Factures"], ["entreprise", "Offres sur devis"],
  ].map(([id, title]) => ({ id, title, blocks: [`${title} : ${fin}.`] })),
};

export const vulnerability = {
  intro: `Vous pensez avoir identifié une faille de sécurité dans ${S} ? Merci de nous la signaler de manière responsable.`,
  sections: [
    { id: "canal", title: "Canal de signalement", blocks: [
      `Adresse dédiée à la sécurité : ${LEGAL.securityEmail}. Tant qu'elle n'est pas publiée, utilisez les coordonnées de la page [Contact](/infos/contact) en précisant « Sécurité » en objet.`,
    ] },
    { id: "infos", title: "Informations utiles", blocks: [{ list: [
      "Description de la vulnérabilité et impact potentiel (par exemple : accès aux données d'un autre Workplace, contournement d'un rôle).",
      "Étapes de reproduction claires.",
      "Composant, URL ou requête concernés.",
      "Vos coordonnées pour le suivi.",
    ] }] },
    { id: "regles", title: "Règles de divulgation responsable", blocks: [{ list: [
      "N'exfiltrez pas de données et ne portez pas atteinte à la vie privée d'autrui.",
      "Ne transmettez pas inutilement de données réelles (Take 5, photos, identités) : utilisez vos propres comptes de test.",
      "Pas de déni de service, pas de destruction ni de modification de données.",
      "Agissez de bonne foi et laissez un délai raisonnable d'analyse et de correction avant toute publication.",
    ] }] },
    { id: "avertissement", title: "Avertissement", blocks: [
      { callout: "Aucun programme de récompense (bug bounty), aucune rémunération et aucun délai de réponse garanti ne sont proposés à ce jour. Chaque signalement de bonne foi est examiné sérieusement." },
    ] },
  ],
};

export const security = {
  intro: `Ce que ${S} met réellement en œuvre pour protéger vos données de terrain. Aucune affirmation non vérifiée.`,
  sections: [
    { id: "auth", title: "Authentification", blocks: [{ list: [
      "Mots de passe hachés avec bcrypt, jamais stockés en clair.",
      "Sessions par cookies sécurisés HttpOnly (jeton d'accès de 15 minutes, renouvellement 7 jours), révoqués à la déconnexion.",
      "Blocage temporaire (15 minutes) après plusieurs échecs de connexion et limitation des changements de mot de passe.",
      "Contrôle de l'origine des requêtes qui modifient des données.",
      "Réinitialisation du mot de passe par lien e-mail à durée limitée.",
    ] }] },
    { id: "autorisations", title: "Autorisations côté serveur et rôles", blocks: [
      "Chaque action est vérifiée par le serveur, quel que soit l'affichage. Un rôle est attribué par Workplace :",
      { table: { head: ["Rôle", "Périmètre"], rows: [
        ["Opérateur", "Réalise ses Take 5 et inspections"],
        ["Chef d'équipe", "Idem, et peut diriger une équipe et ses Take 5 collectifs"],
        ["Superviseur", "Supervision des activités du Workplace, destinataire des alertes de dépassement"],
        ["Contrôleur", "Consultation en lecture seule et journal ; ne réalise pas de Take 5 ni d'inspection"],
        ["Admin", "Administration du Workplace actif uniquement : sites, utilisateurs, équipes, équipements, référentiels locaux"],
        ["Platform Admin", "Gestion des Workplaces et des référentiels globaux, sans lecture des Take 5 et inspections à ce titre"],
      ] } },
      "L'accès aux équipements, aux équipes et aux fonctions administratives est contrôlé selon le rôle et les règles d'affectation (personne, équipe, Workplace).",
    ] },
    { id: "isolation", title: "Isolation des Workplaces", blocks: [
      "Toutes les données métier sont rattachées à un Workplace. Un utilisateur ne voit que les données du Workplace actif. Le changement de Workplace recharge les droits du nouveau rôle, sans mélange avec le précédent.",
    ] },
    { id: "tracabilite", title: "Traçabilité et immutabilité", blocks: [{ list: [
      "Journal d'audit des actions sensibles (création, finalisation, administration).",
      "Un Take 5 finalisé ou une inspection finalisée n'est plus modifiable ; une réévaluation crée une nouvelle trace sans effacer l'historique.",
      "Les mesures retenues sont figées dans le dossier au moment de la finalisation.",
      "Une anomalie critique bloque l'équipement de manière sûre, même en cas d'incident pendant la finalisation.",
    ] }] },
    { id: "offline", title: "Mode hors ligne et synchronisation", blocks: [{ list: [
      "Les opérations hors ligne sont rejouées de façon idempotente : un renvoi ne crée pas de doublon.",
      "Les conflits (par exemple un équipement bloqué entre-temps) sont signalés et ne sont jamais écrasés silencieusement.",
      "Les données locales sont séparées par utilisateur et par Workplace.",
      "Le travail hors ligne est limité à 72 h sans reconnexion.",
      "Le stockage local du navigateur n'est pas chiffré par l'application : protégez l'appareil.",
    ] }] },
    { id: "emails", title: "E-mails transactionnels", blocks: [
      "Les e-mails (mot de passe, invitations, alertes) sont envoyés par un service géré, configuré uniquement par l'administration de la plateforme. Les liens de réinitialisation sont à usage limité et expirent.",
    ] },
    { id: "certifications", title: "Certifications", blocks: [
      { callout: `${S} ne revendique aucune certification (ISO 27001, HDS, SOC 2 ou autre) tant qu'elle n'a pas été réellement obtenue.` },
    ] },
    { id: "signaler", title: "Signaler un problème", blocks: ["Voir la page [Signalement de vulnérabilité](/infos/signalement-vulnerabilite)."] },
  ],
};

export const about = {
  intro: `${S} est une solution d'aide à la prévention terrain, conçue en ${LEGAL.territory} au sein de l'écosystème ${LEGAL.brand}.`,
  sections: [
    { id: "mission", title: "Ce que fait Safe Start", blocks: [{ list: [
      "Take 5 : analyse préalable des risques avant chaque tâche, individuelle ou collective.",
      "Inspections d'équipements et de véhicules, avec blocage en cas d'anomalie critique.",
      "Fonctionnement mobile et hors ligne, avec synchronisation au retour du réseau.",
      "Traçabilité des décisions, journal et export PDF.",
      "Supervision HSE et alertes de dépassement de fin de tâche.",
      "Organisation par Workplaces, sites et équipes.",
    ] }] },
    { id: "principes", title: "Nos principes", blocks: [{ list: [
      "Simple sur le terrain : quelques étapes, lisibles sur mobile.",
      "Factuel : chaque décision est tracée et datée.",
      "Respectueux des données : minimisation et isolation stricte des Workplaces.",
    ] }] },
    { id: "limites", title: "Ce que Safe Start n'est pas", blocks: [
      { callout: DISCLAIMER, tone: "warn" },
      `L'utilisation de ${S} ne rend pas automatiquement une entreprise conforme à ses obligations et n'est associée à aucune certification.`,
    ] },
  ],
};
